import React from 'react';
import '../css/BuyerPlan.css';
import NavbarComponent from './Navbar';
import FooterComponent from './Footer';



const BuyerPlan = () => {
    const plans = [
        {
            id: 1,
            name: "Starter Plan",
            price: "₹299/month",
            features: [
                "Access to standard property listings",
                "Email notifications for new properties",
                "Basic support",
            ],
        },
        {
            id: 2,
            name: "Professional Plan",
            price: "₹799/month",
            features: [
                "Access to premium property listings",
                "Custom property recommendations",
                "Priority email and chat support",
            ],
        },
        {
            id: 3,
            name: "Elite Plan",
            price: "₹1299/month",
            features: [
                "Access to all listings (standard & premium)",
                "Dedicated account manager",
                "24/7 premium support",
                "Early access to new listings",
            ],
        },
    ];

    return (
        <>
            <NavbarComponent />
            <div className="buyer-plan-page">
                <h1>Choose Your Buyer Plan</h1>
                <div className="plans-container">
                    {plans.map((plan) => (
                        <div className="plan-card" key={plan.id}>
                            <h2>{plan.name}</h2>
                            <p className="plan-price">{plan.price}</p>
                            <ul>
                                {plan.features.map((feature, index) => (
                                    <li key={index}>{feature}</li>
                                ))}
                            </ul>
                            <button className="select-plan-button">Select Plan</button>
                        </div>
                    ))}
                </div>
            </div>
            <FooterComponent />
        </>

    );
};

export default BuyerPlan;
